import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonContent, IonSearchbar } from '@ionic/angular/standalone';
import { NavController } from '@ionic/angular';
import { Router, NavigationEnd  } from '@angular/router';
import { filter, distinctUntilChanged } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RsSessionTrackerPage } from '../rs-session-tracker/rs-session-tracker.page';


@Component({
  selector: 'app-rs-headers',
  templateUrl: './rs-headers.page.html',
  styleUrls: ['./rs-headers.page.scss'],
  standalone: true,
  imports: [FormsModule, IonSearchbar, RsSessionTrackerPage]
})
export class RsHeadersPage implements OnInit {

  title = ''
  showTitle = ''
  showSearch = false
  showHeader = false
  
  
  private destroyRef = inject(DestroyRef);

  constructor(private router: Router, private navController: NavController) { }

  ngOnInit() {
    this.getUserName()
    this.router.events.pipe(filter(event => event instanceof NavigationEnd ), distinctUntilChanged((prev, curr)=> (prev as NavigationEnd).urlAfterRedirects === (curr as NavigationEnd).urlAfterRedirects), takeUntilDestroyed(this.destroyRef))
    .subscribe(()=> {
      this.getUserName()
      this.getHeaderData()
    })
  }

  initials = ''
  fullName = ''
  role = '';
  getUserName() {
    const raw = sessionStorage.getItem('user');
    const user = raw ? JSON.parse(raw) : null;
    if (user) {
      const first = (user.first_name ?? '').charAt(0).toUpperCase();
      const last  = (user.last_name  ?? '').charAt(0).toUpperCase();
      this.initials =  `${first}${last}`;
      this.fullName = user?.full_name ?? user?.first_name ?? 'User'; 
        // Get role
      
    }
     const roleRaw = sessionStorage.getItem('role');
  const roleData = roleRaw ? JSON.parse(roleRaw) : null;
    this.role = roleData?.role_name ?? '';
  }

  private getHeaderData() {
    let route = this.router.routerState.root.firstChild; 
    while(route?.firstChild) {
      route = route.firstChild;
    }

    // console.log(route?.snapshot.data)

    this.title = route?.snapshot.data['title']?.label || ''
    this.showTitle = route?.snapshot.data['title']?.showTitle || ''
    this.showSearch = route?.snapshot.data['showSearch'] ?? false;
    this.showHeader = route?.snapshot.data['showHeader'] ?? false;
    // console.log(this.showHeader) // false
  }

  handleLogout() {
    sessionStorage.clear();
    // this.router.navigate(['login'])
    // this.router.navigate(['login'], { replaceUrl: true });
    this.navController.navigateRoot('/login', { animated: false }); // ✅ FIX: clears the entire nav stack instantly — no transition, no flash
  }

}